import { render, staticRenderFns } from "./newGroupMaster.vue?vue&type=template&id=3e3022bc&scoped=true"
import script from "./newGroupMaster.vue?vue&type=script&lang=js"
export * from "./newGroupMaster.vue?vue&type=script&lang=js"
import style0 from "./newGroupMaster.vue?vue&type=style&index=0&id=3e3022bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3022bc",
  null
  
)

export default component.exports